/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import BehaviorIcon from 'icons/BehaviorIcon';

const messages = defineMessages({
  title: {id: 'navigation.behavior.submit-concern'},
});

const SubmitConcernItem = () => (
  <RouteLinkItem
    iconBefore={BehaviorIcon}
    route="midas/students/behavior/submit-concern"
    title={messages.title}
  />
);

export default SubmitConcernItem;
